/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import FeedPostComment from './FeedPostComment';

const FeedPostRepliesContainer = styled('div')`
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;
  padding-left: 90px;
  margin-bottom: 10px;
`;

const FeedPostComments = ({
  feedObject,
  isCollapsed,
}) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);

  const feedPostCommentsMapper = (commentsArray) => commentsArray
    .filter((comment, idx) => !isCollapsed || idx < 2)
    .map((comment) => (
      <FeedPostComment
        key={comment.id}
        feedObject={feedObject}
        comment={comment}
        currentUser={currentUser}
      />
    ));

  return (
    <FeedPostRepliesContainer>
      {feedPostCommentsMapper(feedObject.replies)}
    </FeedPostRepliesContainer>
  );
};

FeedPostComments.propTypes = {
  feedObject: PropTypes.instanceOf(Object).isRequired,
  isCollapsed: PropTypes.bool.isRequired,
};

export default FeedPostComments;
